'use client';
import { useTranslations } from 'next-intl';

import { UiKitCheckboxBase } from '@/fo/ui/kit/checkbox/base';
import { BaseFieldProps } from '@/fo/ui/kit/field/base';

import { saveAgreementState } from './actions';
import { styles } from './Agreements.styles';

export interface AgreementsProps {
  getFieldProps: (name: string) => BaseFieldProps;
  pending: boolean;
  agreementPrivacy?: string;
  /** При передаче показывается чекбокс условий продажи */
  agreementSales?: string;
}

export function Agreements({
  getFieldProps,
  pending,
  agreementPrivacy,
  agreementSales
}: AgreementsProps) {
  const t = useTranslations();
  const slots = styles();

  const handleAgreementSalesChange = async (value: boolean) => {
    getFieldProps('agreementSales').onChange?.(value);
    await saveAgreementState('AGREEMENT_SALES', value);
  };

  const handleAgreementPrivacyChange = async (value: boolean) => {
    getFieldProps('agreementPrivacy').onChange?.(value);
    await saveAgreementState('AGREEMENT_PRIVACY', value);
  };

  return (
    <div className={slots.base()}>
      <UiKitCheckboxBase
        label={t.rich('form.label.agreementPrivacyRegistration', {
          linkPD: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/help/policy/"
              className={slots.link()}
            >
              {chunks}
            </a>
          ),
          linkOffer: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/help/offer/"
              className={slots.link()}
            >
              {chunks}
            </a>
          ),
          linkPrivacy: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/legal/politika-konfidentsialnosti/"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
        {...getFieldProps('agreementPrivacy')}
        onChange={handleAgreementPrivacyChange}
        disabled={pending}
        defaultChecked={agreementPrivacy === 'true'}
      />
      <UiKitCheckboxBase
        label={t.rich('form.label.agreementMarketing', {
          link: (chunks) => (
            <a
              target="_blank"
              rel="noreferrer"
              href="/help/policy/"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
        {...getFieldProps('agreementMarketing')}
        disabled={pending}
      />
      {agreementSales !== undefined && (
        <UiKitCheckboxBase
          label={t.rich('form.label.agreementSales', {
            linkUsage: (chunks) => (
              <a
                target="_blank"
                rel="noreferrer"
                href="/legal/usloviya-ispolzovaniya-sayta-www-naos-ru/"
                className={slots.link()}
              >
                {chunks}
              </a>
            ),
            linkSales: (chunks) => (
              <a
                target="_blank"
                rel="noreferrer"
                href="/legal/usloviya-prodazhi-tovarov/"
                className={slots.link()}
              >
                {chunks}
              </a>
            )
          })}
          {...getFieldProps('agreementSales')}
          onChange={handleAgreementSalesChange}
          disabled={pending}
          defaultChecked={agreementSales === 'true'}
        />
      )}
    </div>
  );
}
